<modal-panel [title]="'ERP sync timeline — ' + (data.tripReference || data.salesOrderId)" (close)="dialogRef.close()">
  @if (loading) {
    <div style="display:flex; justify-content:center; padding: 32px;">
      <mat-spinner diameter="36"/>
    </div>
  } @else if (error) {
    <p class="error-link">{{ error }}</p>
  } @else if (timeline) {
    <div class="timeline-summary">
      <span>SO {{ timeline.tmtSalesOrderId }}</span>
      <span>{{ timeline.tripReference }}</span>
      <span>{{ timeline.mainClientName }}</span>
      <span>Queue rows: {{ timeline.queueRowCount }}</span>
      <span>INITIAL: {{ timeline.initialRowCount }}</span>
      <span>DELTA: {{ timeline.deltaRowCount }}</span>
    </div>
    @if (!timeline.events.length) {
      <p>No sync-queue rows for this sales order.</p>
    }
    <div class="timeline-table-wrap">
      <table class="timeline">
        <thead>
          <tr>
            <th>Queued</th>
            <th>Type</th>
            <th>Entity</th>
            <th>What</th>
            <th>Detail</th>
            <th>Status</th>
            <th>Sent</th>
            <th>D365 SO</th>
            <th>Trailer</th>
            <th>File</th>
            <th>Result</th>
            <th>Error</th>
          </tr>
        </thead>
        <tbody>
          @for (event of timeline.events; track event.syncQueueId) {
            <tr>
              <td>{{ event.dateQueued | date:'M/dd/yyyy HH:mm' }}</td>
              <td>{{ event.changeType }}</td>
              <td>{{ event.changedEntityType }}</td>
              <td>{{ event.entityLabel }}</td>
              <td>{{ event.entityDetail }}</td>
              <td [class]="statusClass(event)">{{ statusLabel(event) }}</td>
              <td>{{ event.erpMessageTimestamp | date:'M/dd/yyyy HH:mm' }}</td>
              <td>{{ latestOrder(event) }}</td>
              <td>{{ latestTrailer(event) }}</td>
              <td>{{ latestFile(event) }}</td>
              <td>{{ latestResult(event) }}</td>
              <td>
                @if (event.errorMessage) {
                  <span class="error-link" (click)="openError('Queue error', event.errorMessage)">Queue</span>
                }
                @for (response of event.responses; track response.erpResponseId) {
                  @if (response.errorDescription) {
                    <div class="error-link" (click)="openError('ERP error', response.errorDescription)">ERP</div>
                  }
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
  <ng-container modalPanelFooter>
    <button mat-button (click)="dialogRef.close()">Close</button>
  </ng-container>
</modal-panel>
